import { makeStyles } from '@material-ui/core';
import logoIcon from '../../assets/branding/logo-icon.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 50,
    display: 'block',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.image} src={logoIcon} alt="RDAP" />;
};
